<wec-loading></wec-loading>
<lib-mini-header [data]="headerLogo" />
<div class="page">
    <router-outlet></router-outlet>
</div>
<app-mini-footer></app-mini-footer>